import React from 'react'
import { Formik, Form } from 'formik'
import {
  CurrencyInputField,
  InputField,
  InputSelectOptions,
  LoaderButton
} from 'components/molecules'
import { Row, Col, Card, Alert } from 'reactstrap'
import PropTypes from 'prop-types'
import { CURATION_STATUS, GENDER } from 'domains/scraper-product/constants/scraper-product-constants'
import ProductCategorySelectField from 'domains/product-category/molecules/select-field'
import ScraperProductAttributeHasReferenceTableFields from 'domains/scraper-product/organisms/dynamic-fields/scraper-product-attribute-has-reference-table-fields'
import { CODE } from 'domains/product-attribute/constants'
import StringUtil from 'utils/string-util'
import { ScraperProductAttachImageCard } from 'domains/scraper-product/organisms/scraper-product-attach-image-card'
import scraperProductCreateSchema from './scraper-product-create-schema'


const propTypes = {
  onSubmitForm : PropTypes.func,
  websites     : PropTypes.arrayOf(
    PropTypes.shape({
      id         : PropTypes.number,
      name       : PropTypes.string,
      url        : PropTypes.string,
      is_enabled : PropTypes.bool
    })
  ),
  isProductCreated         : PropTypes.bool,
  onClickAttachImage       : PropTypes.func,
  onFileSelectionError     : PropTypes.func,
  isImageAttachLoading     : PropTypes.bool,
  setIsImageAttachLoading  : PropTypes.func,
  showAttachImageButton    : PropTypes.bool,
  setShowAttachImageButton : PropTypes.func
}

const defaultProps = {
  onSubmitForm             : () => { },
  websites                 : [ {} ],
  onClickAttachImage       : () => { },
  onFileSelectionError     : () => { },
  isImageAttachLoading     : false,
  setIsImageAttachLoading  : () => { },
  setShowAttachImageButton : () => { }
}

const defaultFormValues = {
  original_sku       : '',
  category           : '',
  website            : '',
  gender             : '',
  price              : '',
  brand              : '',
  size               : '',
  colour             : '',
  product_url        : '',
  delivery_days      : '',
  condition          : '',
  curation_status    : CURATION_STATUS.PENDING,
  image_urls         : [ '' ],
  product_attributes : {
    box             : '',
    dustbag         : '',
    width           : '',
    height          : '',
    length          : '',
    materials       : [ '' ],
    conditions      : '',
    additional_info : ''
  }
}

const ScraperProductCreateForm = ({
  onSubmitForm,
  websites,
  isProductCreated,
  onClickAttachImage,
  onFileSelectionError,
  isImageAttachLoading,
  setIsImageAttachLoading,
  showAttachImageButton,
  setShowAttachImageButton
}) => {

  const handleClickAddImageForm = (
    values,
    setFieldValue
  ) => {
    const oldValue = values.image_urls
    setFieldValue('image_urls', [ ...oldValue, '' ])
  }

  return (
    <Formik
      initialValues={ defaultFormValues }
      enableReinitialize={ true }
      validationSchema={ scraperProductCreateSchema }
      onSubmit={ onSubmitForm }
    >
      {
        ({
          values,
          isSubmitting,
          setFieldValue
        }) => (
          <Form>
            <h4>Website Details</h4>
            <Card body>
              <InputField
                type={ 'select' }
                name={ 'website' }
                label={ 'Website' }
                size={ 'sm' }
                required={ true }
              >
                <option value='' label='Choose one'/>
                {
                  websites.map((website) => (
                    <option
                      key={ website?.name }
                      value={ website?.name }
                      label={ StringUtil.humanize(website?.name) }
                    />
                  ))
                }
              </InputField>
              <InputField
                type={ 'input' }
                name={ 'product_url' }
                placeholder={ 'https://www.example.com/' }
                label={ 'Product URL' }
                size={ 'sm' }
                required={ true }
              />
            </Card>

            <Alert color={ 'primary' }>
              <i className='fas fa-info-circle mr-3' />
              { 'Pada section Attach Scraper Image dan Scraper Image URL, ' }
              { 'boleh diisi 2-2nya ataupun hanya salah satu yang diisi.' }
              <br /><br />&#9673;
              <i>{ ' Attach Scraper Image' }</i>
              { ' memungkinkan untuk memilih lebih dari 1 Image ' }
              { 'dengan menggunakan shift / ctrl saat memilih gambar.' }
              <br /> &#9673;
              <i>{ ' Scraper Image URLs' }</i>
              { ' juga memungkinkan untuk menginput lebih dari 1 Image ' }
              { 'dengan menekan tombol Attach more Image(s).' }
            </Alert>
            <Alert color={ 'secondary' }>
              <i className='fas fa-info-circle mr-3' />
              { 'Khusus Gucci, Loewe, dan Fendi saat ini belum bisa menggunakan ' }
              { 'Image URL, harus menggunakan Attach Image / Upload Image.' }
              <br /><br />
              <p>
                { ' Untuk men-download image dari ketiga website tersebut, ' }
                { 'dapat melihat video tutorial berikut: ' }
              </p>
              <p>
                <a href='https://drive.google.com/file/d/1rsqDTPUWT4pTKtF-cBCwn55TMuRVXC9s/view?usp=sharing'>
                  { 'Menambahkan Image Downloader Extension di Google Chrome' }
                </a>
              </p>
              <p>
                <a href='https://drive.google.com/file/d/1GAC_SKBbrrB4_eJmYbv2d8JUxZIhMInE/view?usp=sharing'>
                  { 'Menambahkan Image Downloader Extension di Mozilla Firefox' }
                </a>
              </p>
              <p>
                <a href='https://drive.google.com/file/d/13ptOE15s05sXQU4W5CY63A8ryVHVmNox/view?usp=share_link'>
                  { 'Cara men-download image dari Gucci, Loewe, dan Fendi' }
                </a>
              </p>
            </Alert>

            <h4>{ 'Attach Scraper Image' }</h4>
            <ScraperProductAttachImageCard
              onClickAttachImage={ (imageData) => onClickAttachImage(imageData) }
              onFileSelectionError={ onFileSelectionError }
              allowChooseCover={ false }
              isImageAttachLoading={ isImageAttachLoading }
              setIsImageAttachLoading={ setIsImageAttachLoading }
              showAttachImageButton={ showAttachImageButton }
              setShowAttachImageButton={ setShowAttachImageButton }
            />

            <h4>{ 'Scraper Image Urls' }</h4>
            <Card body>
              {
                values?.image_urls.map((item, index) => {
                  const showButton = values.image_urls.length === index+1
                  return (
                    <>
                      <InputField
                        key={ `image_urls[${index}]` }
                        type={ 'input' }
                        name={ `image_urls[${index}]` }
                        label={ `Image URL (${index + 1})` }
                        placeholder={
                          'Masukkan URL Gambar yang memiliki format .jpg / .jpeg / .png' +
                          '  ( for example: https://www.example.com/image.jpg )'
                        }
                        size={ 'sm' }
                      />
                      {
                        showButton && (
                          <LoaderButton
                            outline
                            className={ 'my-3' }
                            color={ 'primary' }
                            text={ 'Attach more Image(s)' }
                            onClick={ () => { handleClickAddImageForm(values, setFieldValue) } }
                          />
                        )
                      }
                    </>
                  )
                })
              }
            </Card>

            <h4>{ 'Product Details' }</h4>
            <Row>
              <Col>
                <Card body>
                  <ScraperProductAttributeHasReferenceTableFields
                    code={ CODE.BRAND }
                    label={ CODE.BRAND }
                    required={ true }
                    allow_multiple_values={ false }
                  />
                  <InputField
                    type={ 'select' }
                    name={ 'gender' }
                    label={ 'Gender' }
                    required={ true }
                  >
                    <InputSelectOptions
                      options={ GENDER }
                    />
                  </InputField>
                  <ProductCategorySelectField
                    name={ 'category' }
                    label={ 'Category' }
                    required={ true }
                    gender={ values.gender }
                    allow_multiple_values={ false }
                  />
                  <ScraperProductAttributeHasReferenceTableFields
                    code={ CODE.CONDITION }
                    label={ CODE.CONDITION }
                    required={ true }
                    allow_multiple_values={ false }
                  />
                  <InputField
                    type={ 'input' }
                    name={ 'product_attributes.conditions' }
                    label={ 'Condition (Additional)' }
                    size={ 'sm' }
                  />
                  <CurrencyInputField
                    name={ 'price' }
                    label={ 'Price' }
                    required={ true }
                  />
                </Card>
              </Col>
              <Col>
                <Card body>
                  <InputField
                    type={ 'input' }
                    name={ 'original_sku' }
                    label={ 'Original SKU' }
                    required={ true }
                  />
                  <ScraperProductAttributeHasReferenceTableFields
                    code={ CODE.COLOUR }
                    label={ CODE.COLOUR }
                    required={ true }
                    allow_multiple_values={ false }
                  />
                  <InputField
                    type={ 'input' }
                    name={ 'size' }
                    label={ 'Size' }
                    required={ true }
                  />
                  <ScraperProductAttributeHasReferenceTableFields
                    name={ 'product_attributes.materials' }
                    code={ CODE.MATERIAL }
                    label={ CODE.MATERIAL }
                    allow_multiple_values={ true }
                  />
                  <InputField
                    type={ 'number' }
                    name={ 'delivery_days' }
                    label={ 'Delivery Days' }
                    required={ true }
                  />
                </Card>
              </Col>
            </Row>

            <h4>{ 'Product Measurements' }</h4>
            <Row>
              <Col>
                <Card body>
                  <InputField
                    type={ 'number' }
                    name={ 'product_attributes.width' }
                    label={ CODE.WIDTH }
                  />
                  <InputField
                    type={ 'number' }
                    name={ 'product_attributes.height' }
                    label={ CODE.HEIGHT }
                  />
                  <InputField
                    type={ 'number' }
                    name={ 'product_attributes.length' }
                    label={ CODE.LENGTH }
                  />
                </Card>
              </Col>
              <Col>
                <Card body>
                  <ScraperProductAttributeHasReferenceTableFields
                    name={ 'product_attributes.box' }
                    code={ CODE.BOX }
                    label={ CODE.BOX }
                    allow_multiple_values={ false }
                  />
                  <ScraperProductAttributeHasReferenceTableFields
                    name={ 'product_attributes.dustbag' }
                    code={ CODE.DUSTBAG }
                    label={ CODE.DUSTBAG }
                    allow_multiple_values={ false }
                  />
                </Card>
              </Col>
            </Row>

            <InputField
              type={ 'select' }
              name={ 'curation_status' }
              label={ 'Curation Status' }
              required={ true }
              disabled={ true }
            >
              <InputSelectOptions
                options={ CURATION_STATUS }
              />
            </InputField>

            <Alert color={ 'primary' }>
              <i className='fas fa-info-circle mr-3' />
              { 'Scraped Product akan dikurasi secara otomatis ' }
              { 'oleh sistem pada jadwal yang telah ditentukan.' }
            </Alert>

            <InputField
              type={ 'textarea' }
              rows={ 3 }
              name={ 'product_attributes.additional_info' }
              label={ 'Additional Information' }
            />

            <LoaderButton
              className='float-right'
              color={ 'primary' }
              disabled={ isSubmitting || isProductCreated }
              isLoading={ isSubmitting }
              type='submit'
              text='Submit'
            />
          </Form>
        )
      }
    </Formik>
  )
}

ScraperProductCreateForm.propTypes    = propTypes
ScraperProductCreateForm.defaultProps = defaultProps

export default ScraperProductCreateForm
